import React, { FC } from 'react'
import classNames from 'classnames'
import styles from './RemainsIndicator.module.scss'

const END_THRESHOLD = 10

type Indicator = {
    percent: number
}

type Props = {
    title: string
    indicators: Array<Indicator>
    classes?: {
        scaleIndicator?: string
    }
}

const RemainsIndicator: FC<Props> = ({ title, indicators, classes = {} }) => {
    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>

            <div className={styles.container}>
                <div className={styles.scalesList}>
                    {indicators.map((indicator, index) => {
                        let percent = indicator.percent

                        if (percent < 0) {
                            percent = 0
                        } else if (percent > 100) {
                            percent = 100
                        }

                        return (
                            <div className={styles.scaleWrap} key={index}>
                                <div className={styles.scale}>
                                    <div
                                        className={classNames(
                                            styles.scaleIndicator,
                                            classes.scaleIndicator,
                                            {
                                                [styles.ends]:
                                                    percent < END_THRESHOLD,
                                            }
                                        )}
                                        style={{ height: `${percent}%` }}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>

                {indicators.length > 1 && (
                    <div className={styles.namesList}>
                        {indicators.map((indicator, index) => (
                            <div className={styles.nameItem} key={index}>
                                {index + 1}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default RemainsIndicator
